
import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import ProductosPage from '../pages/productos/page';
import ServiciosPage from '../pages/servicios/page';
import EmpresasPage from '../pages/empresas/page';
import BlogPage from '../pages/blog/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/productos',
    element: <ProductosPage />,
  },
  {
    path: '/servicios',
    element: <ServiciosPage />,
  },
  {
    path: '/empresas',
    element: <EmpresasPage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
